<template>
    <vs-popup class="holamundo edit-group edit-popup import-giftcard-form-popup" title="Import GiftCard" :active.sync="importGiftcardFormPopup.isOpen">
        <div>
            <vs-input label="Code" :maxlength="28" name="code" v-model="code" class="w-full" :danger="err_data['code'].has_err" :danger-text="err_data['code'].err_message" @input="resetErr('code')" />
            
            <label>Status</label>
            <v-select @input="selectStatus($event), resetErr('status')" :value="selected_status" label="name" :options="statusList" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" :searchable="false"
                :class="{'has-err': err_data['status'].has_err}" />
            <span class="text-sm text-danger" v-if="err_data['status'].has_err">{{ err_data['status'].err_message }}</span>
            
            <transition name="list">
                <div v-show="selected_status.status == STATUS_SOLD">
                    <vs-input label="Amount" name="amount" v-model="sold_data.amount" class="w-full" :danger="err_data['amount'].has_err" :danger-text="err_data['amount'].err_message" @input="resetErr('amount')" v-on:keypress="isNumber($event, 'amount')" />
                    
                    <vs-input label="Balance" name="balance" v-model="sold_data.balance" class="w-full" :danger="err_data['balance'].has_err" :danger-text="err_data['balance'].err_message" @input="resetErr('balance')" v-on:keypress="isNumber($event, 'balance')" />
                </div>
            </transition>

            <div class="flex flex-wrap justify-center align-center p-6 mt-6">
                <vs-button class="mr-6 align-center save-responsive" @click="importGiftcard">Import</vs-button>
                <vs-button type="border" color="danger" class="cancel-responsive" @click.stop="closePopup">Cancel</vs-button>
            </div>
        </div>
    </vs-popup>
</template>

<script>
import vSelect from 'vue-select';
export default {
    name: "import-giftcard-form-popup",
    components: { vSelect },
    props: {
        importGiftcardFormPopup: {
            type: Object,
            required: true
        }
    },
    data() {
        const STATUS_NOT_SOLD_YET = 0;
        const STATUS_SOLD = 1;
        // const STATUS_USED_UP = 2;
        // const STATUS_CANCELLED = 99;

        let statusList = [
            { id: 0, name: 'Not Sold Yet', status: STATUS_NOT_SOLD_YET },
            { id: 1, name: 'Sold', status: STATUS_SOLD }
        ];

        let selected_status = { id: -1, name: '' };
        return {
            STATUS_NOT_SOLD_YET,
            STATUS_SOLD,
            code: "",
            statusList,
            selected_status,
            // amount: 0,
            // balance: 0,
            sold_data: { amount: 0, balance: 0 },
            err_data: {
                code: { has_err: false, err_message: "" },
                status: { has_err: false, err_message: "" },
                amount: { has_err: false, err_message: "" },
                balance: { has_err: false, err_message: "" },
            },
            isOpenLoading: false
        }
    },
    watch: {
        importGiftcardFormPopup: {
            immediate: true,
            deep: true,
            handler() {
                if(!this.importGiftcardFormPopup.isOpen) {
                    for(let key in this.err_data) {
                        this.resetErr(key);
                    }
                    this.code = "";
                    this.selected_status = { id: -1, name: '' };
                    this.sold_data = { amount: 0, balance: 0 };
                }
            }
        }
    },
    methods: {
        openLoadingInDiv(){
            this.$vs.loading({
                container: '#app',
                scale: 0.8
            })
            if(this.loadTime){
                clearTimeout(this.loadTime);
                this.loadTime = null;
            }
            this.isOpenLoading = true;
            this.loadTime = setTimeout( ()=> {
                if(this.isOpenLoading) {
                    this.closeLoading();
                    this.$vs.dialog({
                        color: 'danger',
                        title: 'Notification',
                        text: 'Import giftcard failed',
                        acceptText: 'OK'
                    })
                }
            }, 10000);
        },
        closeLoading() {
            this.$vs.loading.close('#app > .con-vs-loading');
            this.isOpenLoading = false;
        },
        closePopup() {
            this.importGiftcardFormPopup.isOpen = false;
        },
        selectStatus(e) {
            this.selected_status = e;
        },
        isNumber: function(evt, type) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            // if ((charCode > 31 && (charCode < 48 || charCode > 57)) || parseInt(this.service_fee_value + '' + evt.key) > this.max) {
            if ((charCode > 31 &&  (charCode < 48 || charCode > 57) && charCode !== 46) 
                || (charCode == 46 && type && this.sold_data[type] && this.sold_data[type].indexOf(".") != -1)) {
                evt.preventDefault();
            } else if (type) {
                if (charCode == 46) {
                    if(this.sold_data[type] == "") {
                        this.sold_data[type] = 0;
                    }
                } else if (this.sold_data[type] === 0 || this.sold_data[type] === '0') {
                    this.sold_data[type] = "";
                }
                return true;
            }
        },
        validateInput() {
            this.err_data.code = this.validObject();
            this.err_data.status = this.validObject();
            this.err_data.amount = this.validObject();
            this.err_data.balance = this.validObject();

            if (this.code == "") {
                this.err_data.code.has_err = true;
                this.err_data.code.err_message = "Code is required";
            } else if (this.code.length < 8) {
                this.err_data.code.has_err = true;
                this.err_data.code.err_message = "Code must have 8-28 characters";
            }

            if (this.selected_status.id == -1) {
                this.err_data.status.has_err = true;
                this.err_data.status.err_message = "Status is required";
            }

            if(this.selected_status.id == this.STATUS_SOLD) {
                if (this.sold_data.amount == "" || parseFloat(this.sold_data.amount) == 0) {
                    this.err_data.amount.has_err = true;
                    this.err_data.amount.err_message = "Amount must be greater than 0";
                }
    
                if (this.sold_data.balance == "" || parseFloat(this.sold_data.balance) == 0) {
                    this.err_data.balance.has_err = true;
                    this.err_data.balance.err_message = "Balance must be greater than 0";
                }
            }

            for (let key in this.err_data) {
                if(this.err_data[key] && this.err_data[key].has_err) {
                    return false;
                }
            }

            return true;
        },
        validObject() {
            return { has_err: false, err_message: "" };
        },
        resetErr(type) {
            if(this.err_data[type]) {
                this.err_data[type] = this.validObject();
            }
        },
        importGiftcard() {
            let isValid = this.validateInput();
            if (isValid) {
                let obj = {
                    code: this.code,
                    amount: this.sold_data.amount,
                    balance: this.sold_data.balance,
                    status: this.selected_status.status
                }
                if(this.selected_status.status != this.STATUS_SOLD) {
                    obj.amount = 0;
                    obj.balance = 0;
                }
                this.openLoadingInDiv();
                this.$store.dispatch("serviceList/CREATE_GIFTCARD", obj).then(() => {
                    this.closeLoading();
                    this.$vs.notify({
                        color: "success",
                        title: "Success",
                        text: "Import giftcard success",
                    });
                    this.$emit("GetData");
                    this.closePopup();
                }).catch((err) => {
                    console.log("Error: ", err);
                    this.closeLoading();
                    this.$vs.notify({
                        color: "danger",
                        title: "Failed",
                        text: "Import giftcard failed",
                    });
                });
            }
        }
    }
}
</script>


<style lang="scss">
.con-vs-popup {
    &.import-giftcard-form-popup {
        .vs-popup {
            .v-select {
                &.vs--open {
                    .vs__dropdown-toggle {
                        border-bottom-left-radius: 4px;
                        border-bottom-right-radius: 4px;
                        box-shadow: 0 1px 0 #ccc;
                    }
                }
                &.has-err {
                    .vs__dropdown-toggle {
                        border-color: rgb(234,84,85);
                    }
                }
                .vs__dropdown-menu {
                    top: 100%;
                    border-radius: 4px;
                    border: 1px solid #ccc;
                    padding: 0;
                    // overflow: hidden;
                    height: 74px;
                    &::-webkit-scrollbar, &::-webkit-scrollbar-track, &::-webkit-scrollbar-thumb {
                        border-top-right-radius: 8px !important;
                        border-bottom-right-radius: 8px !important;
                    }
        
                    li {
                        padding-top: 8px;
                        padding-bottom: 8px;
                        padding-left: 16px;
                        width: inherit;
                        overflow-x: auto;
                    }
                }
            }
        }
    }
}
</style>